import React from "react"
import { useRef } from "react"
import { useTranslation } from "react-i18next"
import { FieldArray, Field, useFormikContext } from "formik"
import { Stack, Button, IconButton, Grid2 as Grid, Typography } from "@mui/material"
import { Add, Delete } from "@mui/icons-material"
import { FormikTextField, FormikSelectVocabolario } from "./formsHelpers"

const SYMBOLS = ["●",  "■", "▲", "+", "x", "−", "=", "•", ":", "○"]

export function EdgeCodesField({ name, label }: { name: string; label: string }) {
  const { t } = useTranslation()
  const { values, setValues } = useFormikContext<any>()
  
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <div>
      {label && (
        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
          {label}
        </Typography>
      )}
      <FieldArray name={name}>
        {({ remove, push }) => (
          <div>
            {values[name] &&
              values[name].length > 0 &&
              values[name].map((_item: string[], index: number) => (
                <React.Fragment key={index}>
                  <Stack key={index} direction="row" spacing={2} alignItems="start" sx={{ my: 2 }}>
                    <Grid container spacing={2} flexGrow={1}>
                      <Grid size={3}>
                        <Field
                          label="Sistema colore"
                          name={`${name}.${index}.sistema_colore`}
                          placeholder="Sistema colore"
                          component={FormikSelectVocabolario}
                          vocabolario="sistema_colore"
                          margin="dense"
                          required
                          fullWidth
                          size="small"
                        />
                      </Grid>
                      <Grid size={3}>
                        <Field
                          label="Cromatismo"
                          name={`${name}.${index}.cromatismo`}
                          placeholder="Cromatismo"
                          component={FormikSelectVocabolario}
                          vocabolario="cromatismo"
                          margin="dense"
                          required
                          fullWidth
                          size="small"
                        />
                      </Grid>
                      <Grid size={3}>
                        <Field
                          label="Edge code"
                          name={`${name}.${index}.edge_code`}
                          placeholder="Edge code"
                          component={FormikTextField}
                          margin="dense"
                          fullWidth
                          size="small"
                          inputRef={inputRef}
                        />
                        
                      </Grid>
                      <Grid size={3}>
                        {SYMBOLS.map((sym) => (
                          <Button
                            key={sym}
                            type="button"
                            size="small"
                            style={{minWidth: '32px'}}
                            onClick={() => {
                              const currentValue = values[name][index].edge_code || ""
                              const newValue = currentValue + sym
                              const newValues = [...values[name]]
                              newValues[index].edge_code = newValue
                              setValues({ ...values, [name]: newValues })
                              inputRef.current?.focus()
                            }}
                            sx={{ mt: 1 }}
                          >
                            {sym}
                          </Button>
                        ))}
                      </Grid>
                      <Grid size={1}>
                        <IconButton
                          title="Elimina riga"
                          sx={{ mt: 1 }}
                          color="error"
                          type="button"
                          onClick={() => {
                            remove(index)
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Stack>
                </React.Fragment>
              ))}

            <Button
              variant="contained"
              type="button"
              size="small"
              onClick={() => push({ codice: "", produttore_pellicola: null })}
              sx={{ mb: 2 }}
            >
              <Add sx={{ mr: 1 }} />
              {t("general.aggiungi_riga")}
            </Button>
          </div>
        )}
      </FieldArray>
    </div>
  )
}
